import { render, staticRenderFns } from "./icon-base.vue?vue&type=template&id=1732a4b6&scoped=true&"
import script from "./icon-base.vue?vue&type=script&lang=js&"
export * from "./icon-base.vue?vue&type=script&lang=js&"
import style0 from "./icon-base.vue?vue&type=style&index=0&id=1732a4b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1732a4b6",
  null
  
)

export default component.exports